import { getToken } from './userStoredData'
import { createAFetch } from '@layers-frontend/commons/helpers/createFetch'

export const graphqlUri = `${window.location.origin}/v1/graphql`

export const afetch = createAFetch({
  uri: graphqlUri,
  getToken
})
